const certifications = [
  {
    name: "AWS Cloud Practitioner",
    subtitle: "Amazon Web Services",
    status: "Completed",
    href: "https://www.credly.com/badges/f0e42a8e-fd2c-4881-a705-fd1c6a89b231/public_url",
  },
  {
    name: "AWS Developer Associate",
    subtitle: "Amazon Web Services",
    status: "Completed",
    href: "https://www.credly.com/badges/396acd44-0b9e-450f-9b1d-af515f2f8dcc/public_url",
  },
  {
    name: "Associate Cloud Engineer",
    subtitle: "Google",
    status: "Completed",
    href: "https://www.credly.com/badges/66e62a90-eece-4150-959c-693bee6fcc57/public_url",
  },
  {
    name: "Cambridge English: Advanced - CAE",
    subtitle: "Cambridge English",
    status: "Completed",
  },
  {
    name: "React Mid-Level",
    subtitle: "Certificates.dev",
    status: "On Going",
  },
];

export default certifications;
